import { render, staticRenderFns } from "./dashMetas.vue?vue&type=template&id=2f901594"
import script from "./dashMetas.vue?vue&type=script&lang=js"
export * from "./dashMetas.vue?vue&type=script&lang=js"
import style0 from "./dashMetas.vue?vue&type=style&index=0&id=2f901594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports